import React from 'react'
import { StyleSheet, css } from 'aphrodite'

// MATERIAL
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

// EXTRA COMPONENTS
import CardComponent from './CardComponent'

// import CardNFC from './CardNFC'
// import CardNFC from './CardNFC'

// ICONS
import IconApps from '../../../assets/icons/IconApps.svg'
import IconNFC from '../../../assets/icons/IconNFC.svg'
import LemonIcon from '../../../assets/LemonIcon.svg';

import IconBlockChain from '../../../assets/icons/IconBlockchain.svg'

export default class CoolStuff extends React.Component{
    render(){
    return(
        <section id="CoolStuff" className="container">
            <div className={css(styles.SecondaryContainer)}>
                <Typography
                style={{marginBottom: 40, fontWeight: 500}} 
                align="center" 
                variant="display1" 
                color="secondary">
                We build cool stuff
                <img src={LemonIcon}
                    style={{height:23, marginLeft: 10,
                    filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.34))'
                    }} 
                     alt=""/>
                </Typography>
                <Grid className={css(styles.GridResponsive)} container justify="center" align="center">
                    <Grid className={css(styles.GridItem)} item md={3} xs={12}>
                        <CardComponent 
                        img={IconApps}
                        title="App Development" 
                        subtitle="Mobile, Desktop & Web Application Development" />
                    </Grid>
                    <Grid className={css(styles.GridItem)} item md={3} xs={12}>
                        <CardComponent 
                        img={IconNFC}
                        title="NFC + IoT" 
                        subtitle="Experts in IoT solutions enhaced with NFC" />
                    </Grid>
                    <Grid className={css(styles.GridItem)} item md={3} xs={12}>
                        <CardComponent 
                        img={IconBlockChain}
                        title="Blockchain" 
                        subtitle="Consulting and development smart contracts and tokens" />
                    </Grid>
                </Grid>
            </div>
        </section>
    )
  }
}

const styles = StyleSheet.create({
    SecondaryContainer: {
        paddingTop: '25%',
        paddingBottom: '15%',
    	color: 'white',
        lineHeight: '1.8em'
    },
    GridItem : {
        margin: '0 .4em',
        '@media (max-width: 950px)' : {
            marginBottom: '1em'
        }
    },
    introButton: {
        color: 'white',
        width: 180,
        background: 'linear-gradient(-161deg, #FF6B4D, #D85944)',
        borderRadius: 200,
        lineHeight: 0,
        paddingRight: '10px',
        marginTop: '5%',
        boxShadow: '0 18px 35px rgba(50,50,93,.1), 0 8px 15px rgba(0,0,0,.07)',
        transition: 'all ease-in-out .2s',
        ':hover':{
            transform: 'translate(0, -2px)',
            boxShadow: '0 20px 40px rgba(50,50,93,.2), 0 8px 15px rgba(0,0,0,.07)',
        }
    },
    rightArrow: {
        backgroundColor: '#F7FCFF',
        color: '#7047D6',
        borderRadius: '188px',
        fontSize: '31px',
        padding: '5px',
        marginLeft: '15px'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/CoolStuff/CoolStuff.js